import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { colorWarning } from 'common/theme'

export const StyledConfirmSubmitModal = styled(Modal)`
  z-index: 10042;

  .modal-content {
    border: 1px solid ${({ theme }) => theme.colors.inputBorder || '#ced4da'};
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.16);
  }

  .modal-dialog {
    max-width: 560px;
  }

  .modal-header {
    background-color: ${({ theme }) => theme.headerSticky?.backgroundColor};
    border-bottom: 1px solid ${({ theme }) => theme.headerSticky?.backgroundColor};

    .modal-title {
      font-size: 20px;
      font-weight: 600;
      color: ${({ theme }) => theme.headerSticky?.text};
      margin-left: 5px;
    }

    .close span {
      font-size: 20px;
      color: ${({ theme }) => theme.headerSticky?.text};
    }
  }

  .modal-body {
    background-color: ${({ theme }) => theme.colors.backgroundText || '#fff'};
    color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
  }

  .modal-footer {
    background-color: ${({ theme }) => theme.colors.backgroundText || '#fff'};
    border-top: 1px solid ${({ theme }) => theme.colors.inputBorder || '#ced4da'};

    .btn-group {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
      width: auto;
      margin-left: auto;
      flex: 0 0 auto;
    }

    .btn-primary {
      background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
      border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
      color: ${({ theme }) => theme.colors.stickyTextColor};

      &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.colors.backgroundText};
        border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
        color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
      }
    }

    .btn-outline-secondary {
      background-color: ${({ theme }) => theme.colors.cancelButtonBackgroundColor};
      color: ${({ theme }) => theme.colors.cancelButtonColor};
      border-color: ${({ theme }) => theme.colors.cancelButtonColor};

      &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.colors.cancelButtonHoverBackgroundColor};
        color: ${({ theme }) => theme.colors.cancelButtonBackgroundColor};
        border-color: ${({ theme }) => theme.colors.cancelButtonHoverBackgroundColor};
      }
    }
  }
`

export const StyledConfirmMessageBody = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`

export const StyledExclamationMark = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colorWarning};
  color: white;
  font-weight: 700;
  flex-shrink: 0;
`

export const StyledConfirmWarningContent = styled.div`
  color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
  line-height: 1.5;
`
